import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useEffect, createElement } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { useCheckbox } from './useCheckbox.js';

var _excluded = ["className", "highlighted", "text", "state", "style"],
    _excluded2 = ["ref"];
var Checkbox = /*#__PURE__*/forwardRef(function Checkbox(props, ref) {
  var _cn;

  var externalClassName = props.className,
      highlighted = props.highlighted,
      text = props.text,
      state = props.state,
      style = props.style,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useCheckbox = useCheckbox(otherProps, ref),
      _useCheckbox$input = _useCheckbox.input,
      internalRef = _useCheckbox$input.ref,
      input = _objectWithoutPropertiesLoose(_useCheckbox$input, _excluded2);

  var checkmarkClassName = cn('yt-input', 'yt-checkmark', (_cn = {
    'yt-input--disabled': props.disabled
  }, _cn["yt-input--state-" + state] = !!state, _cn['yt-input--highlighted'] = highlighted, _cn));
  var checkmarkLabelClassName = cn('cursor-pointer ml-2 text-sm leading-relaxed self-start pt-1 mt-px', {
    'cursor-not-allowed': props.disabled
  });
  var isIndeterminate = input['aria-checked'] === 'mixed';
  useEffect(function () {
    if (internalRef && internalRef.current) {
      internalRef.current.indeterminate = isIndeterminate;
    }
  }, [internalRef, isIndeterminate]);
  return createElement("span", {
    className: cn('flex items-center font-normal h-8', externalClassName),
    style: style
  }, createElement("span", {
    className: "yt-checkbox"
  }, createElement("input", Object.assign({
    ref: internalRef
  }, input)), createElement("span", {
    className: checkmarkClassName
  }, input.checked ? createElement(Icon, {
    name: "tick"
  }) : isIndeterminate ? createElement("span", null) : null)), text && createElement("span", {
    className: checkmarkLabelClassName
  }, text));
});

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
